/* eslint-disable no-loss-of-precision */
import React from 'react'

const Bandana = React.lazy(() => import('../Hats/Bandana'))
const Cowboy = React.lazy(() => import('../Hats/Cowboy'))
const GolfHat = React.lazy(() => import('../Hats/GolfHat'))
const SweatBand = React.lazy(() => import('../Hats/SweatBand'))
const BeachSun = React.lazy(() => import('../Hats/BeachSun'))
const CurvedBillCap = React.lazy(() => import('../Hats/CurvedBillCap'))
const HeadBand = React.lazy(() => import('../Hats/HeadBand'))
const Tophat = React.lazy(() => import('../Hats/Tophat'))
const Beanie = React.lazy(() => import('../Hats/Beanie'))
const Fedora = React.lazy(() => import('../Hats/Fedora'))
const Kippah = React.lazy(() => import('../Hats/Kippah'))
const Trapperhat = React.lazy(() => import('../Hats/Trapperhat'))
const Beret = React.lazy(() => import('../Hats/Beret'))
const FlatBillCap = React.lazy(() => import('../Hats/FlatBillCap'))
const LargeBeanie = React.lazy(() => import('../Hats/LargeBeanie'))
const Turban = React.lazy(() => import('../Hats/Turban'))
const Bucket = React.lazy(() => import('../Hats/Bucket'))
const GangsterBaseballCap = React.lazy(() => import('../Hats/GangsterBaseballCap'))
const Panama = React.lazy(() => import('../Hats/Panama'))
const WinterHat = React.lazy(() => import('../Hats/WinterHat'))

const data = [
  {
    id: 'Bandana',
    svg: Bandana,
    positioning: {
      pointNarrow: {
        y: 57.12567138671875,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 53.716033935546875,
        scaleX: 0.85,
      },
      pointWide: {
        y: 54.178070068359375,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 56.85643005371094,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 58.35493469238281,
        scaleX: 0.75,
      },
      roundWide: {
        y: 53.67716979980469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.31727600097656,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 56.898681640625,
        scaleX: 0.8,
      },
      squareWide: {
        y: 51.72166442871094,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Cowboy',
    svg: Cowboy,
    positioning: {
      pointNarrow: {
        y: 46.77265930175781,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 43.41880798339844,
        scaleX: 0.8,
      },
      pointWide: {
        y: 39.502471923828125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 45.521392822265625,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 46.744781494140625,
        scaleX: 0.85,
      },
      roundWide: {
        y: 44.976959228515625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 48.282806396484375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 45.48419189453125,
        scaleX: 0.85,
      },
      squareWide: {
        y: 48.28764343261719,
        scaleX: 1,
      },
    },
  },
  {
    id: 'GolfHat',
    svg: GolfHat,
    positioning: {
      pointNarrow: {
        y: 58.91841125488281,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 54.066802978515625,
        scaleX: 0.8,
      },
      pointWide: {
        y: 53.12982177734375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 56.79014587402344,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 58.33879089355469,
        scaleX: 0.8,
      },
      roundWide: {
        y: 52.2584228515625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.4622802734375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 56.66761779785156,
        scaleX: 0.8,
      },
      squareWide: {
        y: 52.295654296875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'SweatBand',
    svg: SweatBand,
    positioning: {
      pointNarrow: {
        y: 73.5435791015625,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 69.56326293945312,
        scaleX: 0.8,
      },
      pointWide: {
        y: 66.31777954101562,
        scaleX: 1,
      },
      roundNarrow: {
        y: 72.93229675292969,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 76.630126953125,
        scaleX: 0.8,
      },
      roundWide: {
        y: 70.93482971191406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 74.08503723144531,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 73.25413513183594,
        scaleX: 0.8,
      },
      squareWide: {
        y: 72.39363098144531,
        scaleX: 1,
      },
    },
  },
  {
    id: 'BeachSun',
    svg: BeachSun,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 29.81353759765625,
        scaleX: 0.8,
      },
      pointWide: {
        y: 20.51665496826172,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'CurvedBillCap',
    svg: CurvedBillCap,
    positioning: {
      pointNarrow: {
        y: 51.899810791015625,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 48.12339782714844,
        scaleX: 0.85,
      },
      pointWide: {
        y: 47.83488464355469,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 57.06364440917969,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 53.69865417480469,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50.26274108886719,
        scaleX: 1,
      },
      squareNarrow: {
        y: 54.90814208984375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 53.76264953613281,
        scaleX: 0.85,
      },
      squareWide: {
        y: 48.55216979980469,
        scaleX: 1,
      },
    },
  },
  {
    id: 'HeadBand',
    svg: HeadBand,
    positioning: {
      pointNarrow: {
        y: 60.27650451660156,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 60.630767822265625,
        scaleX: 0.85,
      },
      pointWide: {
        y: 59.167015075683594,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 59.53138732910156,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 59.417938232421875,
        scaleX: 0.85,
      },
      roundWide: {
        y: 58.36418151855469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 59.73469543457031,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 59.588043212890625,
        scaleX: 0.85,
      },
      squareWide: {
        y: 59.093292236328125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Tophat',
    svg: Tophat,
    positioning: {
      pointNarrow: {
        y: 40.58030700683594,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 36.706932067871094,
        scaleX: 0.85,
      },
      pointWide: {
        y: 36.50251770019531,
        scaleX: 1,
      },
      roundNarrow: {
        y: 41.732879638671875,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 42.26783752441406,
        scaleX: 0.85,
      },
      roundWide: {
        y: 38.386627197265625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 39.56781005859375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 40.8167724609375,
        scaleX: 0.85,
      },
      squareWide: {
        y: 36.33604431152344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Beanie',
    svg: Beanie,
    positioning: {
      pointNarrow: {
        y: 49.807525634765625,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 46.55256652832031,
        scaleX: 0.75,
      },
      pointWide: {
        y: 46.94898986816406,
        scaleX: 0.85,
      },
      roundNarrow: {
        y: 50.10218811035156,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 49.98716735839844,
        scaleX: 0.85,
      },
      roundWide: {
        y: 47.51722717285156,
        scaleX: 0.95,
      },
      squareNarrow: {
        y: 49.56608581542969,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 49.4910888671875,
        scaleX: 0.8,
      },
      squareWide: {
        y: 46.756683349609375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Fedora',
    svg: Fedora,
    positioning: {
      pointNarrow: {
        y: 47.04913330078125,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 47.39601135253906,
        scaleX: 0.85,
      },
      pointWide: {
        y: 43.95452117919922,
        scaleX: 1,
      },
      roundNarrow: {
        y: 50.35224914550781,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 49.69007873535156,
        scaleX: 0.85,
      },
      roundWide: {
        y: 44.10308837890625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 48.22547149658203,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 48.57350158691406,
        scaleX: 0.85,
      },
      squareWide: {
        y: 45.262237548828125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Kippah',
    svg: Kippah,
    positioning: {
      pointNarrow: {
        y: 60.55421447753906,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 59.55638122558594,
        scaleX: 0.9,
      },
      pointWide: {
        y: 58.906097412109375,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 61.255126953125,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 60.720977783203125,
        scaleX: 0.85,
      },
      roundWide: {
        y: 61.18463134765625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 59.00596618652344,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 60.259490966796875,
        scaleX: 0.85,
      },
      squareWide: {
        y: 60.28309631347656,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Trapperhat',
    svg: Trapperhat,
    positioning: {
      pointNarrow: {
        y: 59.105865478515625,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 54.11932373046875,
        scaleX: 0.8,
      },
      pointWide: {
        y: 48.34877014160156,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.629302978515625,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 57.24067687988281,
        scaleX: 0.9,
      },
      roundWide: {
        y: 47.60932922363281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 57.74198913574219,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 52.900390625,
        scaleX: 0.9,
      },
      squareWide: {
        y: 51.36967468261719,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Beret',
    svg: Beret,
    positioning: {
      pointNarrow: {
        y: 60.40495300292969,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 50.806854248046875,
        scaleX: 0.85,
      },
      pointWide: {
        y: 53.216407775878906,
        scaleX: 1,
      },
      roundNarrow: {
        y: 58.908050537109375,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 60.43653869628906,
        scaleX: 0.85,
      },
      roundWide: {
        y: 56.24519348144531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 58.89031982421875,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 58.92280578613281,
        scaleX: 0.85,
      },
      squareWide: {
        y: 59.76731872558594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'FlatBillCap',
    svg: FlatBillCap,
    positioning: {
      pointNarrow: {
        y: 57.757415771484375,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 54.760467529296875,
        scaleX: 0.85,
      },
      pointWide: {
        y: 54.162208557128906,
        scaleX: 1,
      },
      roundNarrow: {
        y: 59.21966552734375,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 59.388214111328125,
        scaleX: 0.85,
      },
      roundWide: {
        y: 56.45472717285156,
        scaleX: 1,
      },
      squareNarrow: {
        y: 58.33184814453125,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 58.651885986328125,
        scaleX: 0.85,
      },
      squareWide: {
        y: 53.73899841308594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'LargeBeanie',
    svg: LargeBeanie,
    positioning: {
      pointNarrow: {
        y: 53.40653991699219,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 50.81340026855469,
        scaleX: 0.8,
      },
      pointWide: {
        y: 44.82252502441406,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 51.32994079589844,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 52.560943603515625,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50.3756103515625,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 52.944854736328125,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 50.35728454589844,
        scaleX: 0.85,
      },
      squareWide: {
        y: 49.80859375,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Turban',
    svg: Turban,
    positioning: {
      pointNarrow: {
        y: 52.56640625,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 49.574188232421875,
        scaleX: 0.8,
      },
      pointWide: {
        y: 38.866477966308594,
        scaleX: 0.9,
      },
      roundNarrow: {
        y: 54.70805358886719,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 50.722259521484375,
        scaleX: 0.85,
      },
      roundWide: {
        y: 45.091400146484375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 49.34516906738281,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 47.77064514160156,
        scaleX: 0.85,
      },
      squareWide: {
        y: 46.12290954589844,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Bucket',
    svg: Bucket,
    positioning: {
      pointNarrow: {
        y: 49.806915283203125,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 52.55488586425781,
        scaleX: 0.9,
      },
      pointWide: {
        y: 47.909423828125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 51.75306701660156,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 52.34602355957031,
        scaleX: 0.85,
      },
      roundWide: {
        y: 47.856964111328125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.44183349609375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 50.44938659667969,
        scaleX: 0.9,
      },
      squareWide: {
        y: 48.753570556640625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'GangsterBaseballCap',
    svg: GangsterBaseballCap,
    positioning: {
      pointNarrow: {
        y: 55.67340087890625,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 52.78916931152344,
        scaleX: 0.85,
      },
      pointWide: {
        y: 52.93499755859375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 56.33782958984375,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 56.460968017578125,
        scaleX: 0.85,
      },
      roundWide: {
        y: 57.13853454589844,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.613922119140625,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 57.813262939453125,
        scaleX: 0.85,
      },
      squareWide: {
        y: 57.16758728027344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Panama',
    svg: Panama,
    positioning: {
      pointNarrow: {
        y: 48.88456726074219,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 44.39625549316406,
        scaleX: 0.85,
      },
      pointWide: {
        y: 40.51964569091797,
        scaleX: 1,
      },
      roundNarrow: {
        y: 49.81854248046875,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 49.05964660644531,
        scaleX: 0.85,
      },
      roundWide: {
        y: 44.16218566894531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 48.239593505859375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 46.891204833984375,
        scaleX: 0.85,
      },
      squareWide: {
        y: 43.79986572265625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'WinterHat',
    svg: WinterHat,
    positioning: {
      pointNarrow: {
        y: 31.45836639404297,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 30.365264892578125,
        scaleX: 0.8,
      },
      pointWide: {
        y: 26.880126953125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 31.67534637451172,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 37.3642578125,
        scaleX: 0.75,
      },
      roundWide: {
        y: 28.66161346435547,
        scaleX: 0.95,
      },
      squareNarrow: {
        y: 33.740447998046875,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 31.22144317626953,
        scaleX: 0.85,
      },
      squareWide: {
        y: 29.525474548339844,
        scaleX: 0.9,
      },
    },
  },
]

export default data
